<template>
  <ETooltip :side="tooltipSide">
    <span
      ref="label"
      class="ecosia-label"
      data-test-id="ad-result-label"
    >
      <slot>
        {{ $t("common.search.ad") }}
      </slot>
    </span>
    <template #content>
      {{ $t('common.search.ad.tooltip.text') }}
      <ELink
        :href="learnMoreUrl"
        rel="noopener"
        target="_blank"
        data-test-id="ad-learn-more"
        @click="onLearnMoreClick"
      >
        {{ $t('common.generic.learnmore') }}
      </ELink>
    </template>
  </ETooltip>
</template>

<script>
import { mapState } from 'vuex';

import { HELPSCOUT_AD_LEARN_MORE_URL } from '~~/common/js/constants/urls';

import ELink from '~~/common/vue/components/link';
import ETooltip from '~~/common/vue/components/tooltip';

export default {
  name: 'EAdLabel',
  components: {
    ELink,
    ETooltip,
  },
  props: {
    tooltipSide: ETooltip.props.side,
  },
  computed: {
    ...mapState('global', ['locale']),
    learnMoreUrl() {
      // Helpscout handles localization of the page
      return HELPSCOUT_AD_LEARN_MORE_URL;
    },
  },
  methods: {
    onLearnMoreClick() {
      this.$refs.label.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
// using this instead of ad-label to avoid ad blockers hiding the label
.ecosia-label {
  color: var(--color-text-secondary);
  font-weight: $font-weight-1l;
}
</style>
